document.addEventListener('DOMContentLoaded', function () {

  const root = document.getElementById('SCVisualizer');

  if (!root) return;


  /* =====================================================
     ELEMENTS
  ===================================================== */

  const upload = document.getElementById('SCVUpload');
  const input = document.getElementById('SCVPhotoInput');

  const workspace = document.getElementById('SCVWorkspace');

  const uploadedImage =
    document.getElementById('SCVUploadedImage');

  const processing =
    document.getElementById('SCVProcessing');

  const empty =
    document.getElementById('SCVEmpty');

  const zoomIn =
    document.getElementById('SCVZoomIn');

  const zoomOut =
    document.getElementById('SCVZoomOut');

  const zoomReset =
    document.getElementById('SCVZoomReset');

  const reset =
    document.getElementById('SCVReset');

  const selectedProduct =
    document.getElementById('SCVSelectedProduct');

  const selectedSurface =
    document.getElementById('SCVSelectedSurface');

  const viewProduct =
    document.getElementById('SCVViewProduct');

  const collectionLink =
    document.getElementById('SCVCollectionLink');


  /* =====================================================
     STATE
  ===================================================== */

  let activeSurface = 'floor';

  let zoom = 1;

  let uploadedFile = null;

  const surfaceProducts = {
    floor: null,
    wall: null,
    pool: null
  };


  /* =====================================================
     UPLOAD
  ===================================================== */

  input.addEventListener('change', function (event) {

    const file = event.target.files[0];

    if (!file) return;

    handleUpload(file);

  });


  async function handleUpload(file) {

    if (!file.type.startsWith('image/')) {

      alert('Please upload a JPG, PNG or WEBP image.');

      return;

    }

    uploadedFile = file;

    const imageUrl =
      URL.createObjectURL(file);

    uploadedImage.src = imageUrl;

    upload.classList.add('is-hidden');

    workspace.classList.add('is-visible');

    empty.style.display = 'none';

    processing.classList.add('is-active');

    /*
     * Send image to segmentation API.
     */

    try {

      const result =
        await detectSurfaces(file);

      applySurfaceMasks(result);

    } catch (error) {

      console.error(
        'Surface detection failed:',
        error
      );

      /*
       * We still show the image if AI
       * detection is unavailable.
       */

      showFallbackSurface();

    } finally {

      processing.classList.remove('is-active');

    }

  }


  /* =====================================================
     AI SURFACE DETECTION
  ===================================================== */

  async function detectSurfaces(file) {

    /*
     * Shopify frontend endpoint.
     *
     * Example backend response:
     *
     * {
     *   floor: {
     *      mask: "data:image/png;base64,..."
     *   },
     *   wall: {
     *      mask: "data:image/png;base64,..."
     *   }
     * }
     */

    const endpoint =
      window.SCV_CONFIG &&
      window.SCV_CONFIG.segmentationEndpoint;

    if (!endpoint) {
      throw new Error(
        'Segmentation endpoint not configured'
      );
    }

    const formData =
      new FormData();

    formData.append(
      'image',
      file
    );

    const response =
      await fetch(
        endpoint,
        {
          method: 'POST',
          body: formData
        }
      );

    if (!response.ok) {

      throw new Error(
        'Segmentation request failed'
      );

    }

    return await response.json();

  }


  /* =====================================================
     APPLY MASKS
  ===================================================== */

  function applySurfaceMasks(result) {

    if (!result) return;

    Object.keys(result).forEach(function (surface) {

      const surfaceElement =
        root.querySelector(
          '[data-surface="' + surface + '"]'
        );

      if (!surfaceElement) return;

      const mask =
        result[surface] &&
        result[surface].mask;

      if (!mask) return;

      surfaceElement.style.maskImage =
        'url("' + mask + '")';

      surfaceElement.style.webkitMaskImage =
        'url("' + mask + '")';

      surfaceElement.style.maskRepeat =
        'no-repeat';

      surfaceElement.style.webkitMaskRepeat =
        'no-repeat';

      surfaceElement.style.maskPosition =
        'center';

      surfaceElement.style.webkitMaskPosition =
        'center';

      surfaceElement.style.maskSize =
        '100% 100%';

      surfaceElement.style.webkitMaskSize =
        '100% 100%';

    });

  }


  /* =====================================================
     FALLBACK
  ===================================================== */

  function showFallbackSurface() {

    /*
     * This doesn't attempt fake AI detection.
     *
     * The uploaded image remains visible and the
     * customer can still interact with the product
     * selector once the segmentation service is connected.
     */

    console.warn(
      'No segmentation mask returned.'
    );

  }


  /* =====================================================
     SURFACE SELECTION
  ===================================================== */

  const surfaceTabs =
    root.querySelectorAll(
      '[data-surface-select]'
    );

  surfaceTabs.forEach(function (tab) {

    tab.addEventListener(
      'click',
      function () {

        activeSurface =
          tab.dataset.surfaceSelect;

        surfaceTabs.forEach(
          function (item) {

            item.classList.remove(
              'is-active'
            );

          }
        );

        tab.classList.add(
          'is-active'
        );

        updateActiveSurface();

        updateSelectionBar();

      }
    );

  });


  function updateActiveSurface() {

    const surfaces =
      root.querySelectorAll(
        '.scv-surface'
      );

    surfaces.forEach(
      function (surface) {

        surface.classList.toggle(
          'is-active',
          surface.dataset.surface === activeSurface
        );

      }
    );

  }


  /* =====================================================
     PRODUCT SELECTION
  ===================================================== */

  const products =
    root.querySelectorAll(
      '[data-product]'
    );

  products.forEach(function (product) {

    product.addEventListener(
      'click',
      function () {

        products.forEach(
          function (item) {

            item.classList.remove(
              'is-selected'
            );

          }
        );

        product.classList.add(
          'is-selected'
        );

        surfaceProducts[activeSurface] =
          {
            title:
              product.dataset.title,

            url:
              product.dataset.url,

            texture:
              product.dataset.texture,

            collection:
              product.dataset.collection
          };

        applyProductToSurface(
          activeSurface,
          surfaceProducts[activeSurface]
        );

        updateSelectionBar();

      }
    );

  });


  /* =====================================================
     APPLY PRODUCT TEXTURE
  ===================================================== */

  function applyProductToSurface(
    surface,
    product
  ) {

    if (!product) return;

    const surfaceElement =
      root.querySelector(
        '[data-surface="' + surface + '"]'
      );

    if (!surfaceElement) return;

    const texture =
      surfaceElement.querySelector(
        '[data-texture-for="' + surface + '"]'
      );

    if (!texture) return;

    if (!product.texture) return;

    texture.style.opacity = '0';

    const image =
      new Image();

    image.onload =
      function () {

        texture.src =
          product.texture;

        requestAnimationFrame(
          function () {

            texture.style.opacity =
              '.85';

          }
        );

      };

    image.onerror =
      function () {

        texture.style.opacity =
          '.85';

      };

    image.src =
      product.texture;

  }


  /* =====================================================
     SELECTION BAR
  ===================================================== */

  function updateSelectionBar() {

    const names = {
      floor: 'Floor',
      wall: 'Wall',
      pool: 'Pool / Surround'
    };

    selectedSurface.textContent =
      names[activeSurface] ||
      activeSurface;

    const product =
      surfaceProducts[activeSurface];

    if (!product) {

      selectedProduct.textContent =
        'Choose a stone';

      viewProduct.href =
        '#';

      return;

    }

    selectedProduct.textContent =
      product.title;

    viewProduct.href =
      product.url;

  }


  /* =====================================================
     ZOOM
  ===================================================== */

  function updateZoom() {

    uploadedImage.style.transform =
      'scale(' + zoom + ')';

    root
      .querySelectorAll('.scv-surface')
      .forEach(function (surface) {

        surface.style.transform =
          'scale(' + zoom + ')';

      });

  }


  zoomIn.addEventListener(
    'click',
    function () {

      zoom =
        Math.min(
          zoom + .1,
          2.5
        );

      updateZoom();

    }
  );


  zoomOut.addEventListener(
    'click',
    function () {

      zoom =
        Math.max(
          zoom - .1,
          1
        );

      updateZoom();

    }
  );


  zoomReset.addEventListener(
    'click',
    function () {

      zoom = 1;

      updateZoom();

    }
  );


  /* =====================================================
     RESET
  ===================================================== */

  reset.addEventListener(
    'click',
    function () {

      zoom = 1;

      updateZoom();

      Object.keys(surfaceProducts)
        .forEach(function (surface) {

          surfaceProducts[surface] =
            null;

          const surfaceElement =
            root.querySelector(
              '[data-surface="' + surface + '"]'
            );

          if (!surfaceElement) return;

          const texture =
            surfaceElement.querySelector(
              '.scv-surface__texture'
            );

          if (texture) {

            texture.removeAttribute(
              'src'
            );

          }

        });

      products.forEach(
        function (product) {

          product.classList.remove(
            'is-selected'
          );

        }
      );

      updateSelectionBar();

    }
  );


  /* =====================================================
     INITIAL STATE
  ===================================================== */

  updateActiveSurface();

  updateSelectionBar();

});